import { animate } from "popmotion"
const alwaysOpenMenus = document.querySelectorAll(".current-menu-ancestor")
const menuItems = document.querySelectorAll(".menu-item-has-children")

menuItems.forEach((menuItem) => {
    menuItem.addEventListener("mouseenter", () => {
        if (window.innerWidth <= 992) {
            return
        }

        const other = Array.from(alwaysOpenMenus).find(
            (it) => it.id !== menuItem.id
        )

        if (other) {
            const otherSubmenu = other.querySelector(".sub-menu")
            otherSubmenu.classList.add("other-menu-is-open")
        }

        const submenu = menuItem.querySelector(".sub-menu")
        submenu.classList.add("visible")
    })

    menuItem.addEventListener("mouseleave", () => {
        if (window.innerWidth <= 992) {
            return
        }

        const submenu = menuItem.querySelector(".sub-menu")
        submenu.classList.remove("visible")

        alwaysOpenMenus.forEach((other) => {
            const otherSubmenu = other.querySelector(".sub-menu")
            otherSubmenu.classList.remove("other-menu-is-open")
        })
    })
})

alwaysOpenMenus.forEach((ancestor) => {
    const submenu = ancestor.querySelector(".sub-menu")
    submenu.classList.add("always-visible")
})

const button = document.querySelector(".nav-toggle")
let isMobileNavOpen = false
let currentMobileNavAnimation
const closeButton = document.querySelector(".nav-close")
closeButton.addEventListener("click", () => {
    const headerBottom = document.querySelector(".nav-wrapper")
    if (currentMobileNavAnimation) {
        currentMobileNavAnimation.stop()
    }

    if (isMobileNavOpen) {
        currentMobileNavAnimation = animate({
            from: 1,
            to: 0,
            onComplete: () => {
                headerBottom.style.display = "none"
                isMobileNavOpen = false
            },
            onStop: () => {
                headerBottom.style.display = "none"
                isMobileNavOpen = false
            },
            onUpdate: (value) => (headerBottom.style.opacity = value),
        })
    } else {
        currentMobileNavAnimation = animate({
            from: 0,
            to: 1,
            onPlay: () => {
                headerBottom.style.display = "block"
            },
            onComplete: () => {
                isMobileNavOpen = true
            },
            onStop: () => {
                isMobileNavOpen = true
            },
            onUpdate: (value) => (headerBottom.style.opacity = value),
        })
    }
})

button.addEventListener("click", () => {
    const headerBottom = document.querySelector(".nav-wrapper")
    if (currentMobileNavAnimation) {
        currentMobileNavAnimation.stop()
    }

    if (isMobileNavOpen) {
        currentMobileNavAnimation = animate({
            from: 1,
            to: 0,
            onComplete: () => {
                headerBottom.style.display = "none"
                isMobileNavOpen = false
            },
            onStop: () => {
                headerBottom.style.display = "none"
                isMobileNavOpen = false
            },
            onUpdate: (value) => (headerBottom.style.opacity = value),
        })
    } else {
        currentMobileNavAnimation = animate({
            from: 0,
            to: 1,
            onPlay: () => {
                headerBottom.style.display = "block"
            },
            onComplete: () => {
                isMobileNavOpen = true
            },
            onStop: () => {
                isMobileNavOpen = true
            },
            onUpdate: (value) => (headerBottom.style.opacity = value),
        })
    }
})

const submenuButtons = document.querySelectorAll(".sub-menu-toggle")
submenuButtons.forEach((submenuButton) => {
    // submenuButton.addEventListener("click", () => {
    //     const submenu = submenuButton.parentElement.querySelector(".sub-menu")

    //     submenu.style.display = "block"
    // })

    submenuButton.addEventListener("click", () => {
        if (window.innerWidth > 991) {
            return
        }

        const subMenu = submenuButton.parentElement.querySelector(".sub-menu")
        subMenu.style.opacity = "1"

        const chevron =
            submenuButton.parentElement.querySelector(".sub-menu-toggle")

        if (subMenu.getAttribute("data-is-mobile-nav-open") === "true") {
            animate({
                from: 90,
                to: 0,
                onUpdate: (value) =>
                    (chevron.style.transform = `rotate(${value}deg)`),
            })

            animate({
                from: subMenu.clientHeight,
                to: 0,
                onComplete: () => {
                    subMenu.style.display = "none"
                    subMenu.setAttribute("data-is-mobile-nav-open", false)
                    subMenu.style.height = "auto"
                },
                onUpdate: (value) => (subMenu.style.height = `${value}px`),
            })
        } else {
            animate({
                from: 0,
                to: 90,
                onUpdate: (value) =>
                    (chevron.style.transform = `rotate(${value}deg)`),
            })

            subMenu.style.display = "block"

            animate({
                from: 0,
                to: subMenu.clientHeight,
                onPlay: () => {
                    subMenu.setAttribute("data-is-mobile-nav-open", true)
                },
                onComplete: () => {
                    subMenu.style.height = "auto"
                },
                onUpdate: (value) => (subMenu.style.height = `${value}px`),
            })
        }
    })
})

function addScrollListener() {
    let observer = new IntersectionObserver((entries) => {
        if (entries[0].boundingClientRect.y < 0) {
            const header = document.querySelector("header")
            header.classList.add("scrolled")
        } else {
            const header = document.querySelector("header")
            header.classList.remove("scrolled")
        }
    })
    observer.observe(document.querySelector("#scroll-listener"))
}

addScrollListener()
